import styled from 'styled-components';
import { COLORS } from '@themes';

type StyleProps = {
  $isAnimation: boolean;
  $backgroundColor?: string;
  $border?: string;
  $borderBottom?: string;
};

export const Style = styled.div.attrs((props) => ({}))<StyleProps>`
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? COLORS.BLACK_1};
  ${({ $border, $borderBottom }) =>
    $borderBottom
      ? `border: none; border-bottom: ${$borderBottom};`
      : `border: ${$border ?? `1px solid ${COLORS.BLACK_2}`};`}
  box-sizing: border-box;
  color: ${COLORS.WHITE_1};
  width: 100%;
  height: 70px;
  padding: 16px;
  display: flex;
  ${({ $isAnimation }) => {
    if ($isAnimation) {
      return `animation-name: top-bar;
        animation-duration: 1s;`;
    }
  }}

  position: relative;

  @keyframes top-bar {
    from {
      top: -70px;
      height: 40px;
    }
    to {
      top: 0px;
      height: 70px;
    }
  }

  .name {
    flex: 1;
    display: flex;
    .logo {
      width: 120px;
      border-radius: 6px;
      vertical-align: middle;
      background-color: ${COLORS.WHITE_1};
      padding: 6px 0px;
    }
  }

  .log-out {
    text-align: right;
    color: #fff;
    margin-top: 6px;
    cursor: pointer;
  }
`;
